<!--
  EntityInputDate.vue — the `entity-input-date` widget (also serves `datetime`).
  A readonly v-text-field activator over a v-menu + v-date-picker.

  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (props value/field/rules/disabled/label; emits `input` an ISO yyyy-mm-dd
  string; honors field.params.maxDate === "today"), internal impl re-authored on
  Vuetify 1.5 v-menu/v-date-picker.
-->
<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template slot="activator">
      <v-text-field
        :value="value"
        :label="resolvedLabel"
        :rules="rules"
        :disabled="disabled"
        :required="required"
        prepend-icon="event"
        readonly
        clearable
        @input="onInput"
      />
    </template>
    <v-date-picker
      :value="value"
      :max="maxDate"
      :min="minDate"
      no-title
      scrollable
      @input="onPick"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'entity-input-date',
  props: {
    value: { default: null },
    field: { type: Object, default: () => ({}) },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
  },
  data() {
    return { menu: false };
  },
  computed: {
    params() { return (this.field && this.field.params) || {}; },
    required() { return !!(this.field && this.field.required); },
    resolvedLabel() { return this.label || (this.field && this.field.label) || ''; },
    today() { return new Date().toISOString().slice(0, 10); },
    maxDate() { return this.params.maxDate === 'today' ? this.today : (this.params.maxDate || undefined); },
    minDate() { return this.params.minDate === 'today' ? this.today : (this.params.minDate || undefined); },
  },
  methods: {
    onPick(val) {
      this.menu = false;
      this.$emit('input', val);
    },
    onInput(val) {
      // supports the clearable "x"
      this.$emit('input', val || null);
    },
  },
};
</script>
